import { render, staticRenderFns } from "./Oabot.vue?vue&type=template&id=7569fab8&scoped=true&"
import script from "./Oabot.vue?vue&type=script&lang=js&"
export * from "./Oabot.vue?vue&type=script&lang=js&"
import style0 from "./Oabot.vue?vue&type=style&index=0&id=7569fab8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569fab8",
  null
  
)

export default component.exports